import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconBug,
  IconChartBar,
  IconBuildingBank,
  IconBuildingSkyscraper,
} from '@tabler/icons-react';

const cyberIncidentFeatures: FeatureData[] = [
  {
    title: 'Toute entreprise attaquée',
    description:
      'Son système d\'information est paralysé ou compromis, chaque minute qui passe aggrave les dégâts financiers et opérationnels.',
    icon: <IconBug size={24} />,
    key: 'incidentCyber.features.cyberattack',
  },
  {
    title: 'DSI & responsables IT',
    description:
      'Les équipes sont débordées, elles sont sous la pression de la direction et ont besoin d\'un renfort externe immédiat.',
    icon: <IconChartBar size={24} />,
    key: 'incidentCyber.features.financial',
  },
  {
    title: 'RSSI & équipes sécurité',
    description:
      'Ils ont besoin d\'une équipe d\'investigation numérique (CERT/forensics) pour comprendre l\'étendue de la compromission,.',
    icon: <IconBuildingBank size={24} />,
    key: 'incidentCyber.features.sensitive',
  },
  {
    title: 'Entreprises industrielles',
    description:
      'Pour elles, la réponse à incident doit intégrer la complexité des systèmes industriels et prioriser la reprise des opérations.',
    icon: <IconBuildingSkyscraper size={24} />,
    key: 'incidentCyber.features.large',
  },
];

export default cyberIncidentFeatures; 